import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';

export interface CheckoutTermsType {
    title: string,
    content: string,
}

class CheckoutTerms extends BaseRepositoryClass implements RepositoryType {
    getAll(token: string) {
        return this
            .requester
            .get<Array<CheckoutTermsType>>(`checkout/${token}/terms`);
    }
}

export default CheckoutTerms;
